<template>
  <div :style="customStyle" class="card crd">
    <div class="card-header" :style="headerStyle" v-if="isheader">
      <slot name="card-header">
        {{ header }}
        <!-- @slot The the actions of card  -->
        <slot name="header-actions"></slot>
      </slot>
    </div>
    <div :class="[{ 'card-body': !disableCardBody }, className]">
      <!-- @slot The content container of card body  -->
      <slot name="card-body"></slot>
    </div>
    <div class="card-footer">
      <slot name="card-footer"></slot>
    </div>
  </div>
</template>

<script>
/**
 *
 * Common card component
 *
 */
export default {
  props: {
    /**
     *
     * The header text to be displayed
     *
     */
    header: { type: String },
    /**
     *
     * The class name of the card body
     *
     */
    className: { type: String, default: '' },
    /**
     *
     * Disable the default bootstrap card-body styles
     *
     */
    disableCardBody: { type: Boolean, default: false },
    /**
     *
     * remove header boundry
     */
    headerStyle: { type: Object, default: () => {} },
    /**
     * style of card
     */

    customStyle: { type: Object, default: () => {} },
    isheader: { type: Boolean, default: true },
  },
};
</script>

<style lang="scss" scoped>
.crd {
  width: 100%;
  height: 100%;
  @include dropshadow-effect;
  border-radius: 1.0625em;
  background-color: $bg-secondary;
}
.card-header {
  border-bottom: 0.0125rem solid $border-primary;
  @include flex-center-justify(space-between);
  height: 2.375rem;
  width: 100%;
  color: $font-primary;
  font-family: $semi-bold;
}
.device-app-usage {
  padding-top: 0rem;
  padding-bottom: 0.663rem;
}
</style>
